import { ChangeEvent } from 'react';
import CrossIcon from '../icons/Сross';
import style from './SearchInput.module.css';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
}

const SearchInput = ({ value, onChange, onClear }: SearchInputProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const handleClear = () => {
    onClear();
  };

  return (
    <div className={style.inputContainer}>
      <label className={style.fieldLabel}>Клієнт/Перекладач</label>
      <div className={style.field}>
        <input
          type="text"
          placeholder="Пошук"
          onChange={handleChange}
          value={value}
        />
        {value && (
          <div className={style.crossIcon} onClick={handleClear}>
            <CrossIcon />
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchInput;
